// src/pages/PrivacyPolicy.js

import React from 'react';
import PageHeader from '../components/PageHeader';

const PrivacyPolicy = () => {
    return (
        <>
            <PageHeader
                title="Privacy Policy"
                image="img/privacy.jpg" // use your own path
                breadcrumbs={[
                    { label: "Privacy Policy", active: true },
                ]}
            />
            <div className="container py-5">

                <p>Last Updated:</p>
                <p>At Holiday Basket, we respect your privacy and are committed to protecting your personal data. This
                    policy outlines how we collect, use, and safeguard your information.</p>

                <div>
                    <h3>1. Information We Collect</h3>
                    <p>
                        We may collect the following information
                    </p>
                    <ul>
                        <li>Name, contact information, and travel preferences</li>
                        <li>Passport and visa details for booking and visa processing</li>
                        <li>Payment information (processed securely through third-party gateways)</li>
                        <li>Communications with our support team</li>
                    </ul>

                    <h3>2. How We Use Your Information</h3>
                    <p>
                        Your information is used to
                    </p>
                    <ul>
                        <li>Process bookings and payments</li>
                        <li>Arrange visa and travel services</li>
                        <li>Communicate confirmations, updates, and offers</li>
                        <li>Improve our services and user experience</li>
                        <li>Comply with legal obligations</li>
                    </ul>

                    <h3>3. Data Sharing</h3>
                    <p>
                        We may share your information with
                    </p>
                    <ul>
                        <li>Partner travel service providers (e.g., airlines, hotels, Europamundo Vacations)</li>
                        <li>Visa agencies and consulates</li>
                        <li>Payment processing providers</li>
                        <li>Legal authorities when required by law</li>
                    </ul>
                    <p>We never sell or rent your personal data to third parties.</p>

                    <h3>4. Data Protection</h3>
                    <p>
                        We implement appropriate security measures to protect your data. Access is limited to authorized personnel only.
                    </p>

                    <h3>5. Cookies and Tracking</h3>
                    <p>
                        Our website may use cookies and analytics tools to enhance user experience and monitor site
                        performance. You can manage cookie preferences through your browser settings.
                    </p>

                    <h3>6. Your Rights</h3>
                    <p>
                        You have the right to:
                    </p>
                    <ul>
                        <li>Access or request a copy of your data</li>
                        <li>Request correction or deletion of inaccurate data</li>
                        <li>Withdraw consent where applicable</li>
                    </ul>

                    <h3>7. Contact Us</h3>
                    <p>
                        For any privacy-related concerns or to exercise your rights, please contact:
                        <br />
                        <br />

                        <strong>Holiday Basket</strong><br />
                        Office No E 69, First Floor,<br />
                        your own Business center, Al Maskan Building,<br />
                        Near LuLu Hyper Market - Al Karama,<br />
                        Dubai
                    </p>
                    <p>Email: sales@theholidaybasket.com<br />
                        Phone: +971 52 325 6358</p>
                </div>
            </div>
        </>

    );
};

export default PrivacyPolicy;
